import Swal from "sweetalert2";

/**
 * "Otomatik görev işleme kapanıyor" uyarısının TEK kaynağı.
 *
 * İki yerden çağrılıyor: İşlemler ekranındaki Durdur düğmesi (oturumluk durdurma)
 * ve Ayarlar'daki kalıcı anahtar. Metin tek yerde durmalı — iki ekranda farklı
 * cümle görmek kullanıcıya "bunlar farklı şeyler" izlenimi verirdi.
 */
export const OTOMATIK_GOREV_ISLEME_UYARI_METNI =
    "Görev işleme durdurulursa gece senkron planınız çalışmaz; görevleri elle " +
    "başlatmanız gerekir.";

/**
 * Onaylı uyarı. `true` = kullanıcı devam etmeyi seçti.
 *
 * @param kalici Ayarlar'dan kapatılıyorsa `true` — o zaman tercih KALICI olur ve
 *               başlık bunu açıkça söyler; Durdur düğmesi yalnız oturumluktur.
 */
export async function otomatikGorevIslemeKapatmaOnayi(kalici = false): Promise<boolean> {
    const sonuc = await Swal.fire({
        title: kalici ? "Otomatik görev işleme kapatılsın mı?" : "Görev işleme durdurulsun mu?",
        text: kalici
            ? OTOMATIK_GOREV_ISLEME_UYARI_METNI +
              " Bu ayar kalıcıdır; uygulamayı yeniden açtığınızda da kapalı kalır."
            : OTOMATIK_GOREV_ISLEME_UYARI_METNI +
              " Bu durdurma yalnız bu oturum içindir; uygulamayı yeniden açtığınızda ayarınız geçerli olur.",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: kalici ? "Kapat" : "Durdur",
        cancelButtonText: "Vazgeç"
    });

    return sonuc.isConfirmed === true;
}
